// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ORVqj","controls":"styles_controls__3hLpf","charLimit":"styles_charLimit__1BMXv","input":"styles_input__3uHy5","send":"styles_send__2DVbO"};